import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import { Button, Container, Navbar, Modal, Toast, Alert } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Papa from 'papaparse';
import Pro from './Pro';
import { CartProvider } from '../CartContext';
import Cart from './Cart';
import html2canvas from 'html2canvas';
import { CartContext } from '../CartContext';
import { getProductData } from "../productsStore";
import * as htmlToImage from 'html-to-image';
import { toPng } from 'html-to-image';
import Slider from './Silder';
import { ImCheckmark } from "react-icons/im";
import { images } from '../axAdult';
import ResizableImage from './ResizableComponent';
import { HiOutlineMagnifyingGlassPlus, HiMagnifyingGlassMinus } from "react-icons/hi2";
import SanmarImages from './SanmarImages';
import CompatibleSlider from './CompatibleSlider';
import SubPics from './SubPics';

const ProductDetail = ({ product }) => {
  const { style, csvUrl } = useParams();
  const [message, setMessage] = useState('');
   const [sellType, setSellType] = useState("");
  const [variants, setVariants] = useState([]);
  const [color, setColor] = useState('');
  const [color2, setColor2] = useState('');
  const [Url, setURL] = useState('')
  const [myImage, setMyImage] = useState('');
  const [show2, setShowTime2] = useState(false);
  const [thumId, setThumId] = useState('')
  const [variants2, setVariants2] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [show, setShow] = useState(true);
  const [price, setPrice] = useState("")
  const [id, setId] = useState("")
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageSize, setImageSize] = useState("")
  const [selectedThumPrice, setselectedThumPrice] = useState("")
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hoveredColor, setHoveredColor] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredHex, setHoveredHex] = useState(null);
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [initialMousePosition, setInitialMousePosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false)
  const [isVisible2, setIsVisible2] = useState(false)
  const [uploadedImage, setUploadedImage] = useState(null);
  const [uploadedImagePosition, setUploadedImagePosition] = useState({ top: '40%', left: '50%' });
  const [initialImagePosition, setInitialImagePosition] = useState({ top: 0, left: 0 });
  const [initialTouchPosition, setInitialTouchPosition] = useState({ x: 0, y: 0 });
  const [priceIn, setPriceIn] = useState(false)
  const [showTime, setShowTime] = useState(false)
  const cart = useContext(CartContext);
  const [searchQuery, setSearchQuery] = useState('');
  const [isZoomed, setIsZoomed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [url, setUrl] = useState(null)
  const ref = useRef()
  const navigate = useNavigate()
  // const [capturedImage, setCapturedImage] = useState(null);

  const handleClick = (url) => setSelectedImage(url);

    const embellishmentOnlyBrands = [
    "Brooks Brothers",
    "New Era",
    "Outdoor Research",
    "The North Face",
    "Carhartt",
    "Nike",
    "Stanley/Stella",
    "Tommy Bahama",
    "Cotopaxi",
    "OGIO",
    "tentree",
    "Travis Mathew",
    "Eddie Bauer"
  ];

  const isEmbellishmentOnly = (vendor) => {
    return embellishmentOnlyBrands.some(
      (brand) => brand.toLowerCase() === vendor?.trim().toLowerCase()
    );
  };
  useEffect(() => {
    const csvUrl = '../full-adults-base.csv';
    // const csvUrl = '../fullKids.csv';
    setUrl(csvUrl)
    fetch(csvUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to load CSV file');
        }
        return response.text();
      })
      .then((csvData) => {
        Papa.parse(csvData, {
          complete: (result) => {
            const data = result.data;
            const today = new Date();

            const filteredVariants = data
              .slice(1)
              .filter((item) => item[13] === style)
              .map((item) => {
                const parseDate = (dateStr) => {
                  if (!dateStr) return null;
                  const [month, day, year] = dateStr.split('/').map(Number);
                  return new Date(year, month - 1, day);
                };

                const endSaleDate = parseDate(item[52]);
                const isOnSale = endSaleDate && endSaleDate >= today;

                const price = parseFloat(item[1]) || 0;
                const salePrice = parseFloat(item[48]) || 0;



                let adjustedSalePrice = salePrice;

                //optione fagat $3 off inja tarif mishe
                if (isOnSale && salePrice > 0) {
                  const discount = price - salePrice;
                  if (discount > 3) {
                    adjustedSalePrice = price - 3;
                  }
                }

                return {
                  Handle: item[29],
                  DefaultImageSrc: item[36],
                  HoverImageSrc: item[24],
                  Price: price.toFixed(2),
                  Description: item[3],
                  Color: item[7],
                  Size: item[17],
                  Style: item[13],
                  Hex: item[30],
                  ColorName: item[7],
                  ProductDetail: item[26],
                  ProductDecor: item[27],
                  Id: item[34],
                  Vendor: item[4],
                  tag: item[35],
                  EndSale: endSaleDate,
                  isOnSale,
                  SalePrice: adjustedSalePrice.toFixed(2),
                  weight: item[38],
                  colorName4API: item[58],
                  ImageCircle: item[61], // column 62


                };
              })
            // .filter((variant) => variant.Hex && /^#[0-9A-F]{6}$/i.test(variant.Hex)); // Only valid hex values

            setVariants(filteredVariants);
            setLoading(false);

            if (filteredVariants.length > 0) {
              setSelectedVariant(filteredVariants[0]);
              setMyImage(filteredVariants[0].DefaultImageSrc); // <- use filteredVariants[0] here
            setPrice(filteredVariants[0].Price)
            }
          },
          header: false,
          skipEmptyLines: true,
        });
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [style]);

  const swatchImages = Array.from(
    new Map(
      variants
        .filter((v) => v.Style === style)
        .map((v) => [v.Color, v.ImageCircle]) // key: color, value: image
    )
  );
useEffect(() => {
  if (!selectedVariant) return;

  const result = isEmbellishmentOnly(selectedVariant?.Vendor)
    ? "Sold by Embellishment Only"
    : "Can be Sold Blank";

  setSellType(result);
if (result==="Can be Sold Blank"){
 setPriceIn(true);
}
 

}, [selectedVariant]);

  useEffect(() => {
    if (variants.length > 0 && !selectedColor) {
      const firstHex = [...new Set(variants.map((variant) => variant.Hex))][0];
      setSelectedColor(firstHex);
      const matchedVariant = variants.find(variant => variant.Hex === firstHex);
      if (matchedVariant) {
        // console.log(matchedVariant.Color)

        setColor2(matchedVariant.Color); // <- set the color name state here
      }
    }
  }, [variants]);
  const handleMouseDown = (e) => {
    if (e.button !== 0 && e.type === 'mousedown') return;
    e.preventDefault();
    const rect = ref.current.getBoundingClientRect();
    const imageRect = e.target.getBoundingClientRect();
    setIsDragging(true);
    setInitialMousePosition({ x: e.clientX, y: e.clientY });
    setInitialImagePosition({
      top: imageRect.top - rect.top,
      left: imageRect.left - rect.left,
    });
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      const deltaX = e.clientX - initialMousePosition.x;
      const deltaY = e.clientY - initialMousePosition.y;
      const containerRect = ref.current.getBoundingClientRect();
      const newTop = initialImagePosition.top + deltaY;
      const newLeft = initialImagePosition.left + deltaX;
      const clampedTop = Math.min(Math.max(newTop, 0), containerRect.height - 100);
      const clampedLeft = Math.min(Math.max(newLeft, 0), containerRect.width - 100);
      setUploadedImagePosition({ top: `${clampedTop}px`, left: `${clampedLeft}px` });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleTouchStart = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    const rect = ref.current.getBoundingClientRect();
    const imageRect = e.target.getBoundingClientRect();
    setIsDragging(true);
    setInitialTouchPosition({ x: touch.clientX, y: touch.clientY });
    setInitialImagePosition({
      top: imageRect.top - rect.top,
      left: imageRect.left - rect.left,
    });
  };

  const handleTouchMove = (e) => {
    if (isDragging) {
      const touch = e.touches[0];
      const deltaX = touch.clientX - initialTouchPosition.x;
      const deltaY = touch.clientY - initialTouchPosition.y;
      const containerRect = ref.current.getBoundingClientRect();
      const newTop = initialImagePosition.top + deltaY;
      const newLeft = initialImagePosition.left + deltaX;
      const clampedTop = Math.min(Math.max(newTop, 0), containerRect.height - 100);
      const clampedLeft = Math.min(Math.max(newLeft, 0), containerRect.width - 100);
      setUploadedImagePosition({ top: `${clampedTop}px`, left: `${clampedLeft}px` });
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [isDragging, initialMousePosition, initialTouchPosition, initialImagePosition]);

  const mySrc = `/documents/details/${style}_productmeasurement.pdf`
  const toggleVisibility = () => {
    setIsVisible((prev) => !prev)
    setIsVisible2(false)
  }

  const handleVariantChange = (e, type) => {
    const selectedValue = e.target.value;
    setIsOpen(false);
    // setUploadedImage(null);

    let newColor = selectedColor;
    let newSize = selectedSize;

    if (type === 'Hex') {
      newColor = selectedValue;
      setSelectedColor(newColor);
    } else if (type === 'Size') {
      newSize = selectedValue;
      setSelectedSize(newSize);
      setShowTime(true);
      setShowTime2(true);
    }

    // Always find the variant that matches both color and size
    const updatedVariant = variants.find(
      (variant) =>variant.Color === newColor && variant.Style === style && variant.Size === newSize
    );
// console.log(updatedVariant,newColor,color2)
    if (updatedVariant) {
      // console.log(variants)
      setSelectedVariant(updatedVariant);
      const v = variants.filter((item) => item.Id === updatedVariant.Id);
      setVariants2(v);
      setId(updatedVariant.Id)
       setPrice(updatedVariant.Price);
      // Set color name based on the matching variant
      const matchedVariant = variants.find(variant => variant.Hex === newColor);
      if (matchedVariant) {
        setColor2(matchedVariant.Color);
        setSelectedImage(matchedVariant.DefaultImageSrc)
      }
    }
  };
  const handleThumbnailClick = async (image, position) => {
    alert("Click on the uploaded image! You can resize & move it to the proper position! Click Outside the image to deselect it!")
    if (selectedVariant.tag === "Youth,Sweatshirts/Fleece") {
      setImageSize("16%")
    }
    if (selectedVariant.tag === "Youth,T-Shirts") {
      setImageSize("25%")
    }
    if (selectedVariant.tag === "Youth,Caps") {
      setImageSize("19%")
    }
    if (selectedVariant.tag === "Infant & Toddler,T-Shirts") {
      setImageSize("22%")
    }
    if (selectedVariant.tag === "Infant & Toddler,Zipper") {
      setImageSize("15%")
    }
    if (selectedVariant.tag === "pants") {
      setImageSize("15%")
    }
    if (selectedVariant.tag === "polos") {
      setImageSize("13%")
    }
    if (selectedVariant.tag === "Zipper") {
      setImageSize("13%")
    }
    setId(selectedVariant.Id)
    if (selectedSize === "") {
      alert("You have not selected any size!")
      return
    }
    setselectedThumPrice(image.Alt);
    setThumId(image.id)
    setUploadedImage(image.src);
    setPrice(selectedVariant.Price)
    setPriceIn(true)
    const payamurl = selectedVariant.DefaultImageSrc
    setURL(payamurl)

    const response = await fetch("https://api-shipping-28612190fdf4.herokuapp.com/image", {
      // const response = await fetch("http://localhost:4000/image", {
      method: "POST",
      body: JSON.stringify({ imageUrl: payamurl }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(data => {
        document.getElementById('myImage').style.backgroundImage = 'url(' + data.image + ')';
        // document.getElementById('magnifying-glass').style.display = 'none';
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };
  const handleSubmit = async (base64Image, chunkSize = 50000) => {
    const totalChunks = Math.ceil(base64Image.length / chunkSize);
    // console.log(totalChunks)
    for (let i = 0; i < totalChunks; i++) {
      const chunk = base64Image.slice(i * chunkSize, (i + 1) * chunkSize);

      const response = await fetch('https://api-shipping-28612190fdf4.herokuapp.com/customerimage', {
        // const response = await fetch('http://localhost:4000/customerimage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Explicitly set the content type to JSON
        },
        body: JSON.stringify({
          chunk,
          chunkIndex: i,
          totalChunks // Sending base64 image as JSON payload
        }),
      });

      const result = await response.json();
      if (response.ok) {
        console.log('Image uploaded successfully:'
          // , result.url
        ); // `url` key in the response
      } else {
        console.error('Error uploading image:', result.message);
      }

    }

  };
  const uploadImageToCloudinary = async (base64Image) => {
    try {
      const response = await fetch('https://api.cloudinary.com/v1_1/dcuturlmb/image/upload', {
        method: 'POST',
        body: new URLSearchParams({
          file: base64Image,
          upload_preset: 'ml_default',
        }),
      });

      const data = await response.json();
      return data.secure_url;

    } catch (error) {
      console.error('Error uploading image:', error);
    }
  };

  const handleFileChange = async (event) => {
    setPriceIn(true);
    setPrice(selectedVariant.Price);
    setId(selectedVariant.Id);
    setselectedThumPrice("15"); // price vase DTF miad inja
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64Image = reader.result; // This is a base64 string
        const result = await uploadImageToCloudinary(base64Image)
        // console.log(result);
        setUploadedImage(result);
        // setUploadedImage(base64Image);
        setThumId("Personal");
        await handleSubmit(base64Image); // Pass base64 string to handleSubmit
      };
      reader.readAsDataURL(file); // Read the image file as base64
    }

    const p = variants.find((variant) => variant.Hex === selectedColor)?.ColorName;
    setColor(p);
  };

  let myTotal = (parseFloat(price)).toFixed(2)
  const products = [
    {
      id: id, title: `${style}`, name: `${style}`, price: `${parseFloat(myTotal)}`,
      Thum_Price: `${selectedThumPrice}`, size: `${selectedSize}`, colorHex: `${selectedColor}`
      , color: `${color}`,
      //  image:`${capturedImage}`,
      thumImage: `${uploadedImage}`, thumId: `${thumId}`,
      image2: `${Url}`, image3: `${myImage}`, rating: `${0}`
    }
  ];
  // console.log(products)
  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Filter images based on the search query (case-insensitive)
  // const filteredImages = images.filter((image) =>
  //   image.src.toLowerCase().includes(searchQuery.toLowerCase())

  // );
const filteredImages = images.filter((image) => {
  const normalizedSrc = image.src
    .split('/').pop()            // get just the filename
    .replace(/\.[^/.]+$/, '')    // remove file extension
    .replace(/-/g, ' ')          // replace dashes with spaces
    .toLowerCase();

  const words = searchQuery.trim().toLowerCase().split(/\s+/);

  const matches = words.every(word => normalizedSrc.includes(word));

  // 🧪 Console Debug
  // console.log('-------------------------');
  // console.log('Image:', image.src);
  // console.log('Normalized:', normalizedSrc);
  // console.log('Search Words:', words);
  // console.log('Matches:', matches);

  return matches;
});



  // sending measurement from resizable
  const handleMessageFromChild = (msg) => {
    setMessage(msg);
  };
  // Handle outside click to reset zoom
  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setIsZoomed(false);
    }
  };
  // Attach event listener for outside click
  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // Handle zoom toggle
  const toggleZoom = (e) => {
    e.stopPropagation();
    setIsZoomed(!isZoomed);

  };
  return (
    // <Container>
    <div className="product-detail"  >

      {selectedVariant && (
        <>
          {show && (<button style={{ justifyItems: "center", marginBottom: 10, width: 250, height: 55, fontSize: 23, textAlign: "center", fontWeight: "bold", alignContent: "center" }} className="button-85">{style}</button>)}
  <p>{sellType}</p>


          <div
            className={`spotlight ${isZoomed ? 'zoomed' : ''}`}
            ref={ref}
            id="myImage"
            style={{
              backgroundImage: `url(${selectedImage || selectedVariant?.DefaultImageSrc})`,
          
              pointerEvents: 'auto',
              transition: 'transform 0.3s ease',
              transform: isZoomed ? 'scale(2)' : 'scale(1)',
            }}
            onMouseEnter={() => setIsHovered(true)} // When mouse enters, set hover state
            onMouseLeave={() => setIsHovered(false)} // When mouse leaves, reset hover state
          >
            {uploadedImage && (
              <>



                <ResizableImage src={uploadedImage} color={selectedVariant.Color} sendMessage={handleMessageFromChild} />

              </>)}
            <div
              className="magnifying-glass"
              id="magnifying-glass"
              style={{
                position: 'absolute',
                bottom: '15px',
                right: '10px',
                cursor: 'pointer',
                display: 'block',

                width: 20,
                height: 20,
                objectFit: "cover",
                color: isHovered ? 'grey' : 'white', // Conditional color based on hover state
              }}


            >
              {isZoomed ? (
                <HiMagnifyingGlassMinus onClick={toggleZoom} size={20} style={{ marginTop: -10, marginLeft: -2 }} />
              ) : (
                <HiOutlineMagnifyingGlassPlus onClick={toggleZoom} size={20} style={{ marginTop: -10, marginLeft: -2 }} />
              )}
            </div>
          </div>
          <div> <SubPics currentStyle={style} url={url} path={"product-adult"} onImageClick={handleClick} color={color2} /></div>
  
          <div className="product-info">
            <div >


              <div className="variant-options"  >
                <div className="option" style={{ marginTop: -40, color: "navy" }} >
                  <label htmlFor="size">Select Size:</label>
                  <select id="size" value={selectedSize} onChange={(e) => handleVariantChange(e, 'Size')}>
                    <option value="">Select Size</option>
                    {Array.from(new Set(variants.map((variant) => variant.Size))).map((size, index) => (
                      <option key={index} value={size}>
                        {size}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {show2 && (

                <div className="variant-options" >
                  <div className="option">
                                        <SanmarImages inputNumber={style} color={selectedVariant?.ColorName} />
                    <label htmlFor="color" style={{ marginTop: -20, color: "navy" }} >Select Color:</label>


                    <div className="color-options" style={{ padding: 10 }}>
                      {swatchImages.map(([color, imageUrl], index) => {
                        // Get the exact variant for this swatch color
                        const variant = variants.find(
                          (v) => v.Style === style && v.Color === color
                        );

                        if (!variant) return null;

                        return (
                          <div
                            key={index}
                            className="color-circle"
                            style={{
                              position: 'relative',
                              borderRadius: '50%',
                              overflow: 'hidden',
                              width: 30,
                              height: 30,
                              margin: 5,
                              cursor: 'pointer',
                              backgroundImage: `url(${imageUrl})`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              border: selectedVariant.Color === color ? '2px solid black' : '1px solid #ccc',
                            }}
                            onClick={() => {
                         
                              handleVariantChange({ target: { value: color } }, 'Hex')
                              const matchedVariant = variants.find(
                                (v) => v.Color === color && v.Style === style && v.Size === selectedSize,

                              );
                        
                              if (matchedVariant) {
                                setSelectedVariant(matchedVariant);
                                setColor2(matchedVariant.Color);// ✅ Update selected variant
                                setSelectedImage(matchedVariant.DefaultImageSrc); // ✅ Change main image
                                setId(matchedVariant.Id);
                              setPrice(matchedVariant.Price)
                              }
                            }}
                            onMouseEnter={() => setHoveredHex(selectedVariant.Color)}
                            onMouseLeave={() => setHoveredHex(null)}
                          >
                            {/* Checkmark if selected */}
                            {selectedColor === color && (
                              <div
                                className="selected-indicator"
                                style={{
                                  position: 'absolute',
                                  top: '90%',
                                  left: '30%',
                                  transform: 'translate(-30%, -50%)',
                                  // backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                  borderRadius: '50%',
                                  padding: 0,
                                }}
                              >
                                <ImCheckmark />
                              </div>
                            )}

                          
                          </div>
                        );
                      })}
                    </div>


                  </div>
                </div>
              )}
              <div style={{ marginTop: -10 }}>
                <h4 style={{ color: "navy" }} onClick={toggleVisibility}>
                  <i>
                    {isVisible ? "Show Less" : "Show More"}
                  </i>
                </h4>

                {isVisible && (
                  <>
                    <div
                      className="product-details2"
                      style={{ fontSize: '20px', marginLeft: '30px' }}
                      dangerouslySetInnerHTML={{ __html: selectedVariant.Description }} />
                    <div>
                      {mySrc &&(
                                              <h4 onClick={() => setIsVisible2(!isVisible2)}>
                        PRODUCT_MEASUREMENTS
                      </h4>
                      )}

                    </div>
                  </>
                )}
                {isVisible2 && (
                  <div className='iframe'>
                    <iframe title={style} width={300} height={200} src={mySrc}></iframe>
                    <hr></hr>
                  </div>
                )}
              </div>
              {selectedVariant && show && (
                <>
                  {/* <p className="price" style={{ color: "navy" }}>Item Price: ${parseFloat((selectedVariant.Price)).toFixed(2)}</p> */}

                  {selectedVariant.isOnSale ? (

                    <div style={{ marginBottom: 10 }}>
                      <p className="price" style={{ color: 'navy', marginBottom: 4 }}>Item Price:</p>
                      <p className="price" style={{ textDecoration: 'line-through', color: 'navy', marginBottom: 4 }}>
                        ${parseFloat(selectedVariant.Price).toFixed(2)}
                      </p>
                      <p style={{ color: 'red', fontWeight: 'bold', fontSize: 18 }}>
                        ${parseFloat(selectedVariant.SalePrice).toFixed(2)}
                      </p>
                    </div>
                  ) : (
                    <p className="price" style={{ color: "navy" }}>
                      Item Price: ${parseFloat(selectedVariant.Price).toFixed(2)}
                    </p>
                  )}
                  {showTime && (
                    <div className="sth">
                      <div className="v" style={{ width: "100%", justifyContent: "center", textAlign: "center", marginLeft: "auto", marginRight: "auto" }}>
                        <h5 style={{ color: "navy" }}>Available designs: <span style={{ fontSize: 14 }}>({filteredImages.length})</span> </h5>
                      </div>
                      <div className="product-container">
                        <div className="search-box">
                          <input
                            type="text"
                            placeholder="What you looking for..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                          />
                        </div>
                        <div className="product">
                          <div className="product-thumbnails">
                            {filteredImages.map((image, index) => (
                              <div
                                key={index}
                                className="thumbnail"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleThumbnailClick(image)}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                              >
                                <img id="ax" src={image.src} alt={image.Alt} />
                                {hoveredIndex === index && (
                                  <div className="alt-text">{image.name}</div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="fileInput" >
                        <label style={{ color: "navy" }}>Choose your file (for better result .png format with no background only!)</label>
                        <p>
                        </p>
                        <div >
                          <input style={{ color: "navy" }} type="file" id="myFile" accept="png" onChange={handleFileChange} />
                        </div>
                        {priceIn && id && (
                          <div className='FinalItem' style={{ marginTop: "10px" }}>
                            <div>
                              <div>
                                {products.map(product => (
                                  <div key={product.id}>
                                    <Cart product={product} myArr={variants2} show={show} setShow={setShow} size={selectedSize}
                                      color={selectedVariant.Color} thumPrice={selectedThumPrice} thum={selectedThumbnail}
                                      image2={myImage.image}
                                      image={myImage} thumImage={uploadedImage}
                                      thumId={thumId}
                                      forwardRef={ref}
                                      url={selectedVariant.DefaultImageSrc}
                                      rating={0}
                                      Artsize={message.area}
                                      salePrice={selectedVariant.SalePrice}
                                      isOnSale={selectedVariant.isOnSale}
                                      weight={selectedVariant.weight}
                                      colorName4API={selectedVariant.colorName4API}
                                      imageSize1={message.width}
                                      imageSize2={message.height}
                                      imageSize3={message.widthInches}
                                      imageSize4={message.heightInches}
                                      finalImage={selectedImage}
                                       uploadedImage={uploadedImage}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <CompatibleSlider currentStyle={style} url={url} path={"product-adult"} />
                    </div>
                  )}

                </>
              )}
            </div>
          </div>
        </>
      )}
      {/* {priceIn && (
          <div className='FinalItem' style={{ marginTop: "10px" }}>
            <div>
              <div>
                {products.map(product => (
                  <div key={product.id}>
                    <Cart product={product} myArr={variants2} show={show} setShow={setShow} size={selectedSize}
                      color={selectedVariant.Color} thumPrice={selectedThumPrice} thum={selectedThumbnail}
                      image2={myImage.image}
                      image={myImage} thumImage={uploadedImage}
                      thumId={thumId}
                      forwardRef={ref}
                      url={selectedVariant.DefaultImageSrc}
                      rating={0}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )} */}


    </div>
    // </Container>
  );
};

export default ProductDetail;
